module.exports = __webpack_public_path__ + "media/assets/images/google_play_sm-eng-ef85d9743eac18e3beca44aec5cb5c73.png";